// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"741":"2f08d5e0","781":"36482f33","787":"f945334e"}[chunkId] + ".chunk.js";
};